import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/brand/brand identity.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const BrandIdentity = () => {
  const heroData = {
    title: "Complete Brand Identity Development",
    description: "Build a cohesive brand identity system that tells your story and connects with your audience. We create comprehensive visual languages that establish market presence and drive brand equity.",
    image: img13,
    imageAlt: "Brand Identity",
    features: [
      "Visual identity system",
      "Brand style guide",
      "Marketing collateral",
      "Digital assets",
      "Brand voice & messaging",
      "Application templates",
    ],
    pillars: [
      "Cohesive visual system that unifies all brand touchpoints",
      "Strategic positioning that differentiates you from competitors",
      "Scalable framework that grows with your business",
    ],
  };

  const journeySteps = [
    {
      title: "Brand Strategy & Audit",
      description: "We analyze your market position, competitive landscape, and brand values to create a strategic foundation.",
      details: ["Brand audit", "Market analysis", "Audience research", "Positioning strategy", "Brand architecture", "Value proposition"],
    },
    {
      title: "Visual Identity Creation",
      description: "Our design team develops a complete visual language including logo, colors, typography, and graphic elements.",
      details: ["Logo design system", "Color palette", "Typography selection", "Graphic elements", "Imagery style", "Pattern library"],
    },
    {
      title: "Brand Guidelines Development",
      description: "We create comprehensive guidelines that ensure consistent brand application across all channels and materials.",
      details: ["Usage guidelines", "Do's and don'ts", "Application examples", "Digital templates", "Print specifications", "Brand voice guide"],
    },
    {
      title: "Implementation & Rollout",
      description: "Launch your new identity with marketing materials, digital assets, and ongoing support for seamless brand adoption.",
      details: ["Marketing collateral", "Digital assets", "Social media kit", "Brand training", "Launch materials", "Ongoing support"],
    },
  ];

  const capabilities = [
    {
      title: "Brand Strategy",
      content:
        "Comprehensive brand positioning, messaging architecture, and strategic frameworks that define your market presence.",
    },
    {
      title: "Visual Identity System",
      content:
        "Complete design system with logo, color palette, typography, patterns, and graphic elements for all applications.",
    },
    {
      title: "Brand Guidelines",
      content:
        "Detailed brand books and usage guidelines that ensure consistent application across all channels and touchpoints.",
    },
    {
      title: "Marketing Collateral",
      content:
        "Business cards, letterheads, brochures, presentations, and all branded materials for professional communication.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "180%", label: "Brand awareness increase" },
      { value: "85%", label: "Customer recognition rate" },
      { value: "60+", label: "Brand assets delivered" },
    ],
    description: "We deliver comprehensive brand identities that drive recognition, build trust, and create lasting market impact across all touchpoints.",
  };

  const outcomesData = {
    description: "We create complete brand identity systems that establish professional presence, ensure consistency, and differentiate you in the market.",
    outcomes: [
      "Complete logo system with variations",
      "Comprehensive brand style guide",
      "Color palette and typography system",
      "Marketing collateral templates",
      "Digital and social media assets",
      "Brand voice and messaging guidelines",
    ],
  };

  const whyChooseUs = [
    {
      title: "Strategic Approach",
      content:
        "We combine creative excellence with strategic thinking to build brands that resonate and perform in the market.",
    },
    {
      title: "Comprehensive Delivery",
      content:
        "Get everything you need to launch and maintain your brand, from guidelines to templates and assets.",
    },
    {
      title: "Industry Expertise",
      content:
        "Our team has built identities for startups, enterprises, and everything in between across 50+ industries.",
    },
    {
      title: "Long-Term Partnership",
      content:
        "We provide ongoing support and evolution of your brand as your business grows and markets change.",
    },
  ];

  const faqs = [
    {
      q: "What's included in a complete brand identity package?",
      a: "A complete brand identity includes logo system with variations, comprehensive brand style guide, color palette and typography system, graphic elements and patterns, marketing collateral templates, digital and social media assets, and brand voice guidelines. You'll receive everything needed to launch and maintain consistent branding."
    },
    {
      q: "How is brand identity different from just a logo?",
      a: "A logo is just one element of your brand identity. Complete brand identity encompasses your entire visual system including typography, colors, graphic elements, imagery style, and application guidelines. It's a cohesive framework that ensures consistency across all touchpoints and builds stronger brand recognition."
    },
    {
      q: "How long does brand identity development take?",
      a: "A comprehensive brand identity project typically takes 6-8 weeks from discovery to final delivery. This includes strategy development (1-2 weeks), design exploration (2-3 weeks), refinement (1-2 weeks), and guideline creation (1-2 weeks). Timeline can be adjusted based on project scope and urgency."
    },
    {
      q: "Can you refresh our existing brand without starting over?",
      a: "Absolutely! Brand evolution or refresh is often the right approach when you need modernization while maintaining brand equity. We can update your visual identity, refine your messaging, and expand your system while preserving elements that already have market recognition and value."
    }
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Brand Identity"}
            pagesub={"Branding & Design"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Brand Identity Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default BrandIdentity;
